import {useMutation, useQueryClient} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface SendToChannelPayload {
  title?: string;
  body: string;
}

interface SendToChannelResponse {
  messages: Array<{
    id: number;
    channel_id: number;
    recipient_count: number;
    title: string;
    body: string;
  }>;
}

export default function useSendToChannelApi(channelId: number) {
  const queryClient = useQueryClient();

  const sendToChannel = async (
    payload: SendToChannelPayload,
  ): Promise<SendToChannelResponse> => {
    if (!channelId) throw new Error('channel_id is required');
    if (!payload?.body?.trim()) throw new Error('body is required');

    const response = await ChessRestClient.post<SendToChannelResponse>(
      `/inbox/send_to_channel/${channelId}`,
      {
        title: payload.title ?? '',
        body: payload.body.trim(),
      },
    );

    return response?.data ?? {messages: []};
  };

  return useMutation(sendToChannel, {
    onSuccess: () => {
      queryClient.invalidateQueries(['inbox']);
      queryClient.invalidateQueries(['messages', channelId]);
    },
  });
}
